import Cookies from 'js-cookie'
import store from '../index'

import {deepClone, replaceDocumentIconAndTitle} from '@/utils'
import {getNameCode, removeToken, setToken} from '@/utils/cookie'
import {clearStore, getStore, setStore} from '@/utils/store'

import {loginOut} from '@/api/common/auth/authUser'
import {login as captchaLogin, phoneLogin as phoneCaptchaLogin} from '@/api/common/auth/captcha'
import {formatRoutes, handleRouteByUserRole} from '@/utils/router/other'
import {businessRoutes, platformRoutes} from '@/router/routes'
import router from '@/router'
import {getSystemUserInfo} from '@/api/business/user'
import {getTenantInfo} from '@/api/platform/tenant'
import {refreshToken} from '@/api/common/login'
import {getPlatformUserInfo} from '@/api/platform/user'

const login = {
  state: {
    access_token: getStore({name: 'access_token'}) || '',
    refresh_token: getStore({name: 'refresh_token'}) || '',
    routes: getStore({name: 'routes'}) || [],
    // 左侧菜单
    menus: getStore({name: 'menus'}) || [],
    // 用户信息
    userInfo: getStore({name: 'userInfo'}) || {},
    // 租户信息
    tenantInfo: getStore({name: 'tenantInfo'}) || {},
    // 租户配置
    tenantConfig: getStore({name: 'tenantConfig'}) || {},
    // 档案配置
    archivesConfig: getStore({name: 'archivesConfig'}) || {
      totalCollectTimes: 5,
      desensitization: 0
    },
    // 登录类型 normal：普通登录；SSO：单点登录
    loginType: getStore({name: 'loginType'}) || 'normal',
    diseaseType: getStore({name: 'diseaseType'}) || null
  },
  actions: {
    /**
     * 添加平台管理员登录后路由
     */
    addPlatformRoutes({commit}) {
      commit('SET_ROUTES', platformRoutes)
      router.addRoutes(formatRoutes(platformRoutes))
    },
    /**
     * 添加租户登录后路由
     */
    addBusinessRoutes({commit, state}) {
      const routes = handleRouteByUserRole(businessRoutes, state.userInfo.userRole)
      commit('SET_ROUTES', routes)
      router.addRoutes(formatRoutes(routes))
    },
    /**
     * 登录(拼图验证码)
     */
    jigsawCaptchaLogin({commit, state, dispatch}, form) {
      return new Promise((resolve, reject) => {
        captchaLogin(form)
          .then((response) => {
            let respData = response.data
            if (respData.code === 0) {
              let data = respData.data
              // commit('initIndex')
              commit('SET_ACCESS_TOKEN', data.access_token)
              commit('SET_REFRESH_TOKEN', data.refresh_token)
            }
            resolve(respData)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    /**
     * 登录(拼图验证码) 手机号登录
     */
    jigsawCaptchaPhoneLogin({commit, state, dispatch}, form) {
      return new Promise((resolve, reject) => {
        phoneCaptchaLogin(form)
          .then((response) => {
            let respData = response.data
            if (respData.code === 0) {
              let data = respData.data
              // commit('initIndex')
              commit('SET_ACCESS_TOKEN', data.access_token)
              commit('SET_REFRESH_TOKEN', data.refresh_token)
            }
            resolve(respData)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    /**
     * 登出
     */
    LogOut() {
      return new Promise((resolve, reject) => {
        loginOut().then(() => {
          clearState()
          clearStore()
          removeToken()
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    /**
     * 清除缓存
     */
    FedLogOut({commit}) {
      return new Promise((resolve) => {
        // 清除用户信息
        commit('SET_USER_INFO', {})
        commit('SET_ACCESS_TOKEN', '')
        commit('SET_REFRESH_TOKEN', '')
        // clearStore()
        removeToken()
        resolve()
      })
    },
    /**
     * 刷新用户信息
     */
    refreshUserInfo({commit, state, dispatch}) {
      getSystemUserInfo().then(({data}) => {
        if (data.code === 0) {
          commit('SET_USER_INFO', data.data)
        }
      })
    },
    /**
     * 刷新平台人员信息
     */
    refreshPlatformUserInfo({commit, state, dispatch}) {
      getPlatformUserInfo().then(({data}) => {
        if (data.code === 0) {
          commit('SET_USER_INFO', data.data)
        }
      })
    },
    /**
     * 刷新租户信息
     */
    refreshTenantInfo({commit}) {
      getTenantInfo(getNameCode(), true).then(({data}) => {
        if (data.code === 0) {
          commit('SET_TENANT_INFO', data.data)
          replaceDocumentIconAndTitle()
        } else {
          router.replace('/404')
        }
      }).catch(() => {
        router.replace('/404')
      })
    }
  },
  mutations: {
    /**
     * 刷新token
     */
    REFRESH_TOKEN: (state, token) => {
      refreshToken({refresh_token: Cookies.get('refresh_token')}).then((response) => {
        let data = response.data
        if (data && data.code === 0) {
          // 保存token到store和cookie
          store.commit('SET_ACCESS_TOKEN', data.data.access_token)
          // 保存refresh_token
          store.commit('SET_REFRESH_TOKEN', data.data.refresh_token)
        }
      })
    },

    /**
     * 保存路由
     */
    SET_ROUTES: (state, routes) => {
      state.routes = routes
      setStore({
        name: 'routes',
        content: state.routes
      })
    },
    /**
     * 保存左侧菜单
     */
    SET_MENUS: (state, menus) => {
      state.menus = menus
      setStore({
        name: 'menus',
        content: state.menus
      })
    },
    /**
     * 设置access_token
     */
    SET_ACCESS_TOKEN: (state, accessToken) => {
      state.access_token = accessToken
      setToken(accessToken)
      setStore({
        name: 'access_token',
        content: state.access_token
      })
    },

    /**
     * 设置refresh_token
     */
    SET_REFRESH_TOKEN: (state, rfToken) => {
      state.refresh_token = rfToken
      Cookies.set('refresh_token', rfToken)
      setStore({
        name: 'refresh_token',
        content: state.refresh_token
      })
    },
    /**
     * 设置用户信息
     */
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
      setStore({
        name: 'userInfo',
        content: state.userInfo
      })
    },
    /**
     * 设置租户信息
     */
    SET_TENANT_INFO: (state, tenantInfo) => {
      state.tenantInfo = tenantInfo
      setStore({
        name: 'tenantInfo',
        content: state.tenantInfo
      })
    },
    /**
     * 设置租户配置
     */
    SET_TENANT_CONFIG: (state, tenantConfig) => {
      state.tenantConfig = tenantConfig
      setStore({
        name: 'tenantConfig',
        content: state.tenantConfig
      })
    },
   /**
     * 设置档案配置
     */
    SET_ARCHIVES_CONFIG: (state, archivesConfig) => {
      state.archivesConfig = archivesConfig
      setStore({
        name: 'archivesConfig',
        content: state.archivesConfig
      })
    },
    /**
     * 设置登录类型
     */
    SET_LOGIN_TYPE: (state, loginType) => {
      state.loginType = loginType
      setStore({
        name: 'loginType',
        content: state.loginType
      })
    },
    /**
     * 设置默认病种
     */
    SET_DEFAULT_CODE: (state, diseaseType) => {
      state.diseaseType = diseaseType
      setStore({
        name: 'diseaseType',
        content: state.diseaseType
      })
    }
  }
}

export default login

/**
 * 重置store里所有数据
 */
export const clearState = function () {
  let initState = deepClone(window.initState)
  store.state.app = initState.app
  store.state.login = initState.login
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js